import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { updateWhyChooseUsSection } from "../../api/apiWhyChooseUs";
import parseError from "../../utils/parseError";

export const useUpdateWhyChooseUsSection = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    const mutation = useMutation({
        mutationFn: (data) => updateWhyChooseUsSection(data),
        onSuccess: (response) => {
            queryClient.invalidateQueries({ queryKey: ["why-choose-us-section"] });
            toast.success(
                response?.message ||
                (isArabic ? "تم تحديث بيانات لماذا نحن" : "Why Choose Us section updated")
            );
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || (isArabic ? "تعذر التحديث" : "Failed to update"));
        },
    });

    return mutation;
};
